import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  details: null,
  selectedProject: null,
  searchProject: '',
  isModalOpenAddProject: false,
  refetchProject: null,
  isOpenSelectionProject: false,
  filledName: '',
}

export const projectSlice = createAppSlice({
  name: 'project',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag.size = payload.size
      state.tag.page = payload.page
    }),
    setSelectedProject: create.reducer((state, { payload }) => {
      state.selectedProject = payload
    }),
    setSearchProject: create.reducer((state, { payload }) => {
      state.searchProject = payload
    }),
    setIsModalOpenAddProject: create.reducer((state, { payload }) => {
      state.isModalOpenAddProject = payload
    }),
    setRefetchProject: create.reducer((state, { payload }) => {
      state.refetchProject = payload
    }),
    setIsOpenSelectionProject: create.reducer((state, { payload }) => {
      state.isOpenSelectionProject = payload
    }),
  }),
})

export const {
  setFetchOption,
  setSelectedProject,
  setSearchProject,
  setIsModalOpenAddProject,
  setRefetchProject,
  setIsOpenSelectionProject,
} = projectSlice.actions

export default projectSlice.reducer
